import { useCallback } from "react"
import * as XLSX from "xlsx"

type ExportColumn = {
  field: string
  headerName: string
  valueGetter?: (row: any) => any
}

export const useReportExport = () => {
  const exportToExcel = useCallback(
    (data: any[], columns: ExportColumn[], filename: string) => {
      const rows = data.map((row) => {
        const obj: Record<string, any> = {}
        for (const col of columns) {
          const value = col.valueGetter ? col.valueGetter(row) : row[col.field]
          obj[col.headerName] = value ?? ""
        }
        return obj
      })

      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, "Report")
      XLSX.writeFile(wb, `${filename}.xlsx`)
    },
    [],
  )

  const copyToClipboard = useCallback(
    (data: any[], columns: ExportColumn[]) => {
      const headers = columns.map((c) => c.headerName).join("\t")
      const rows = data
        .map((row) =>
          columns
            .map((col) => {
              const value = col.valueGetter ? col.valueGetter(row) : row[col.field]
              return String(value ?? "")
            })
            .join("\t"),
        )
        .join("\n")
      navigator.clipboard.writeText(`${headers}\n${rows}`)
    },
    [],
  )

  return { exportToExcel, copyToClipboard }
}
